import * as React from "react";

import primaryColour from "../constants";

function SvgPolygon(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={20} viewBox="0 0 24 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6823 1.19629L22.9289 3.6456L18.0033 18.4224L0.820312 11.0583L10.6823 1.19629ZM11.0544 2.4252L2.80317 10.6764L17.3183 16.8972L21.4493 4.50419L11.0544 2.4252Z"
        fill={fill}
      />
      <path d="M9.73596 0.678711H12.0001V2.94286H9.73596V0.678711Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0566 0H12.6792V3.62264H9.0566V0ZM9.73585 0.679245V2.9434H12V0.679245H9.73585Z"
        fill={fill}
      />
      <path d="M0.679356 9.73535H2.94351V11.9995H0.679356V9.73535Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.05664H3.62264V12.6793H0V9.05664ZM0.679245 9.73589V12H2.9434V9.73589H0.679245Z"
        fill={fill}
      />
      <path d="M16.5284 16.5283H18.7926V18.7925H16.5284V16.5283Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8491 15.8486H19.4717V19.4713H15.8491V15.8486ZM16.5283 16.5279V18.792H18.7925V16.5279H16.5283Z"
        fill={fill}
      />
      <path d="M21.0567 2.94336H23.3209V5.20751H21.0567V2.94336Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3774 2.26367H24V5.88631H20.3774V2.26367ZM21.0566 2.94292V5.20707H23.3208V2.94292H21.0566Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgPolygon;
